<template>
  <div class="l-learn-title">
    <!-- 标题 -->
    <div class="l-learn-title-header">{{ element ? element.name : '' }}</div>
    <span @click="onBack" oncontextmenu="return false;" draggable="false" class="l-back"></span>
  </div>
</template>

<script>
import elementTypes from '../../minxin/elementTypes'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-title',
  data() {
    return {
      // studentRecordId: '',
      // lessonCourseInfoId: '',
      // sceneCourseInfoId: '',
      reviewFlag: false,
    }
  },
  computed: {
    ...mapGetters(['element']),
    isPreviewStudy() {
      return (
        this.SOURCE_TO_ELEMENT[this.$route.params.elementType] ===
          this.ELEMENT_TYPES.STUDY_MESSAGE ||
        this.SOURCE_TO_ELEMENT[this.$route.params.elementType] ===
          this.ELEMENT_TYPES.PREVIEW_AUDIO ||
        this.SOURCE_TO_ELEMENT[this.$route.params.elementType] ===
          this.ELEMENT_TYPES.PREVIEW_VIDEO
      )
    },
  },
  mixins: [elementTypes],
  mounted() {
    // this.studentRecordId = this.$route.query.studentRecordId
    // this.lessonCourseInfoId = this.$route.query.lessonCourseInfoId
    // this.sceneCourseInfoId = this.$route.query.sceneCourseInfoId
  },
  methods: {
    onBack() {
      if (this.isPreviewStudy) {
        this.$router.back(-1)
      } else {
        // 其他的由组件自己定义
        this.$emit('back')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
